var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"image-input"},[_c('input',{attrs:{"type":"file","accept":"image/png, image/gif, image/jpeg"},on:{"change":_vm.fileChange}}),_c('p',[_vm._v(_vm._s(_vm.inputText))]),_c('div',{staticClass:"image-icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }